const environment: 'audrey' | 'shark' = 'shark';

const bridgeWarGui = false;

export const gameDataHost = 'https://gamedata.onlinebridgeclub.com';

const emailSupport = 'support@sharkbridge.info'; //'support@betterbridge.com'; //:

export { environment, emailSupport, bridgeWarGui };
